<template>
    <div class="m-view__pass">
        <h5 class="title"></h5>
        <div class="slogen">
            <p>神兵全额补贴，根据当前单人或结义小队累计最高神兵和活跃度</p>
            <p>（计算本人和小队成员活动期内提升），领取奖励</p>
        </div>

        <div class="eq-pass pass-pannel" v-if="$store.state.task">
            <div class="token-info score">
                <p class="cnt">{{ number_fix($store.state.task[tid_eq].rate || $store.state.userinfo.equip || 0) }}</p>
            </div>

            <div class="reward-list flex-between-start">
                <div class="reward-item" v-for="(item,index) in $store.state.task[tid_eq].subList" :key="index"
                :class="{'act' : index < $store.state.task[tid_eq].finishRate , 'dismiss' : index < $store.state.task[tid_eq].giftRate }">
                    <div class="require">{{ number_fix(item.value) }}</div>
                    <div class="status">
                        <div class="i-status sprite sprite-icon-checked_s" v-if="index < $store.state.task[tid_eq].finishRate"></div>
                        <div class="i-status sprite sprite-icon-locked" v-else></div>
                    </div>
                    <div class="goods-detail">
                        <div class="goods-wrapper">
                            <div class="goods-pic" v-tips="item.giftList[0].giftId"><game-item :locked="true" :id="item.giftList[0].giftId" :num="item.giftList[0].sendNum"></game-item></div>
                        </div> 
                        <div class="item-name">{{ item.giftList[0].giftName }}</div> 
                    </div>                   
                </div>                
            </div>
        </div>

        <div class="active-pass pass-pannel" v-if="$store.state.task">
            <div class="token-info active">
                <p class="cnt">{{ number_fix($store.state.task[tid_active].rate) }}</p>
            </div>

            <div class="reward-list flex-between-start">
                <div class="reward-item" v-for="(item,index) in $store.state.task[tid_active].subList" :key="index"
                :class="{'act' : index < $store.state.task[tid_active].finishRate , 'dismiss' : index < $store.state.task[tid_active].giftRate }">
                    <div class="require">{{ item.value }}</div>
                    <div class="status">
                        <div class="i-status sprite sprite-icon-checked" v-if="index < $store.state.task[tid_active].finishRate"></div>
                        <div class="i-status sprite sprite-icon-locked" v-else></div>
                    </div>
                    <div class="goods-detail">
                        <div class="goods-wrapper">
                            <div class="goods-pic" v-tips="item.giftList[0].giftId"><game-item :locked="true" :id="item.giftList[0].giftId" :num="item.giftList[0].sendNum"></game-item></div>
                        </div> 
                        <div class="item-name">{{ item.giftList[0].giftName }}</div> 
                    </div>                   
                </div>                
            </div>           
        </div>

        <div class="u-btn apply sprite sprite-btn-apply" @click="task_apply()"
        :class="{'dismiss' : $store.state.task[this.tid_eq].giftRate == $store.state.task[this.tid_eq].finishRate && $store.state.task[this.tid_active].giftRate == $store.state.task[this.tid_active].finishRate,
        'disabled' : $store.state.task[this.tid_eq].finishRate == 0 && $store.state.task[this.tid_active].finishRate == 0
        }"></div>
    </div>
</template>

<style lang="scss" scoped>
.title{
    width: 577px;
    height: 170px;
    margin: 0 auto;
    background-image: url(~@/assets/images/title-1.png);   
}

.slogen{
    // margin-top: -100px;
    color: #ecb785;
    text-align: center;
}

.pass-pannel{
    display: flex;
    // align-items: center;
}

.token-info{
    font-size: 28px;
    color: #63372a;
    width: 114px;
    height: 300px;
    padding-top: 100px;
    box-sizing: border-box;
    text-align: center;

    &.score{
        background-image: url(~@/assets/images/label-score.png);
    }

    &.active{
        background-image: url(~@/assets/images/label-active.png);
    }

    .cnt{
        color: #ece9d5;
        font-size: 32px;
        font-weight: 700;
        //background-image: url(~@/assets/images/bg-cnt.png);   
    }
}

.reward-list{
    //background-image: url(~@/assets/images/bg-list.png);
    margin-top: 5px;
    background-position: top center;
    background-repeat: no-repeat;

    .reward-item{
        position: relative;
        width: 129px;
        height: 253px;
        padding-top: 20px;
        margin: 0 14px;
        box-sizing: border-box;
        background-image: url(~@/assets/images/item-pass.png);

        .status{
            position: relative;
            width: 100%;
            height: 42px;
            margin-bottom: 22px;

            .i-status{
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                z-index: 10;
            }

            &::after{
                content: '';
                display: block;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                width: 157px;
                height: 6px;
                background-color: #472317;
            }
        }
        
        &.act{
            .goods-detail{
                //background-image: url(~@/assets/images/item-pannel_act.png);
            }

            .require{
                color: #63372a;
            }
        }

        &.dismiss{
            .goods-wrapper::after{
                content: '';
                display: block;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                width: 68px;
                height: 68px;
                background-image: url(~@/assets/images/icon-dismiss.png);
                background-repeat: no-repeat;
                background-position: center center;
                pointer-events: none;
            }
        }
    }

    .goods-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 82px;
        height: 82px;
        margin: 0 auto;
        background-image: url(~@/assets/images/bg-item.png);        
    }

    .require{
        font-weight: 700;
        text-align: center;
        color: #996527;
    }

    .item-name{
        margin-top: 5px;
        padding: 0 20px;
        font-size: 20px;
        color: #785726;
        text-align: center;
    }
}

.eq-pass{
    margin-top: 40px;
}

.active-pass{
    margin-top: 40px;
}

.u-btn.apply{
    margin: 55px auto 0;
}
</style>

<script>
import { apiTaskApply } from '@/api/index';

export default {
    data (){
        return {
            tid_eq : 't01',
            tid_active : 't02',
        }
    },
    methods : {
        task_apply(){
            //todo
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            apiTaskApply({taskOrderId : [this.$store.state.task[this.tid_eq].taskOrderId,this.$store.state.task[this.tid_active].taskOrderId]})
            .then(
                res => {
                    this.$msg_modal({type : 'success' ,})
                    this.$update_evt();
                },
                rej => {
                    this.$toast(rej.message);
                },
            );
        },
        number_fix(num){
            return num > 99999 ? Math.floor((num/10000)) + '万' : num;
        },
    },
}
</script>